import { thunkProgress } from 'redux-progress';

import type { Dispatch, GetState } from 'model/State';
import {
  hasSourceDownloads,
  getProductSourceDownload,
  getSourceDownloadURL,
} from 'modules/mac/duck/api/downloads';
import {
  FETCH_HAS_SOURCE_DOWNLOADS,
  FETCH_PRODUCT_SOURCE_DOWNLOAD,
  FETCH_SOURCE_DOWNLOAD_URL,
} from './types';

export const fetchHasSourceDownloads = (textValue: string) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();

  const hasSourceDownloadsData = hasSourceDownloads(textValue, state);
  dispatch(
    thunkProgress(FETCH_HAS_SOURCE_DOWNLOADS, hasSourceDownloadsData, { product: textValue }),
  );
};

export const fetchProductSourceDownload = (productKey) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();

  const getProductSourceDownloadData = getProductSourceDownload(productKey, state);
  dispatch(thunkProgress(FETCH_PRODUCT_SOURCE_DOWNLOAD, getProductSourceDownloadData, {}));
};

export const fetchSourceDownloadURL = (sourceId, downloadType) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();

  const getSourceDownloadURLData = getSourceDownloadURL(sourceId, downloadType, state);
  dispatch(thunkProgress(FETCH_SOURCE_DOWNLOAD_URL, getSourceDownloadURLData, {}));
};
